// We're getting a bunch of html from the server and shoving it into react here.

import * as React from 'react';
import {Link as RouterLink, withRouter} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import {Api} from 'nutshell-core/api';

import {Link} from 'shells/link/link';

import {PageTitleBar} from '../layout';
import {PageWrapper} from '../layout/page-wrapper';

import 'less/demio.less';

type Props = {
    viewUrl: string;
    viewParams: string;
};

type State = {
    serverMarkup: string | null | undefined;
    didRenderServerMarkup: boolean;
};

const viewApi = new Api('/');
const headers = new Headers({
    'Content-Type': 'application/xhtml+xml',
    accept: '*/*',
    'X-Requested-With': 'XMLHttpRequest',
});

export class DemioPage extends React.Component<Props, State> {
    constructor() {
        // @ts-expect-error
        super();
        this.state = {
            serverMarkup: null,
            didRenderServerMarkup: false,
        };
    }

    componentDidMount() {
        this.fetchNewMarkup();
    }

    componentDidUpdate(prevProps: Props, prevState: State) {
        if (
            prevProps.viewUrl !== this.props.viewUrl ||
            prevProps.viewParams !== this.props.viewParams
        ) {
            this.fetchNewMarkup();
        }

        if (
            prevState.serverMarkup !== this.state.serverMarkup ||
            prevState.didRenderServerMarkup !== this.state.didRenderServerMarkup
        ) {
            if (this.state.didRenderServerMarkup) {
                Nut.updateAppearances();
                Nut.preparePage();
                setUpEvents();
            }
        }
    }

    render() {
        return (
            <PageWrapper header={<PageTitleBarContainerRouted />}>
                {this.state.serverMarkup ? (
                    <div
                        ref={(ref) => {
                            if (ref && !this.state.didRenderServerMarkup) {
                                this.setState({didRenderServerMarkup: true});
                            }
                        }}
                        dangerouslySetInnerHTML={{
                            __html: this.state.serverMarkup,
                        }}
                    />
                ) : null}
            </PageWrapper>
        );
    }

    fetchNewMarkup = () => {
        this.setState({
            serverMarkup: null,
        });

        // Strip possible trailing slash
        const baseUrl = this.props.viewUrl.replace(/\/$/, '');
        const url = `${baseUrl}.webchunk${this.props.viewParams}`;

        viewApi
            // @ts-expect-error
            .get(url, undefined, headers)
            .then((res) => {
                // @ts-expect-error
                if (res.redirected) {
                    // @ts-expect-error
                    window.location = res.url;
                }

                return res;
            })
            // @ts-expect-error
            .then((res) => res.text())
            .then((body) => {
                this.setState({
                    serverMarkup: body,
                });
            });
    };
}

function setUpEvents() {
    $('.demio-log-participant-activity').on('click', function () {
        const logButton = $(this);

        // @ts-expect-error
        logButton.attr('disabled', true);

        Nut.ajax.post({
            url: '/demio/log-participant',
            data: {
                contactId: logButton.data('contact-id'),
                webcastTimestamp: logButton.data('webcast-timestamp'),
            },
            success: function () {
                logButton.addClass('status-logged');
            },
        });
    });
}

class PageTitleBarContainer extends React.PureComponent<ContextRouter> {
    render() {
        let pageTitle = '';
        let buttons;

        if (this.props.location.pathname === '/demio/upcoming') {
            pageTitle = 'Upcoming webcasts';
            buttons = (
                // @ts-expect-error
                <Link variant='button-secondary' size='big' to='/demio' as={RouterLink}>
                    Past webcasts
                </Link>
            );
        } else if (this.props.location.pathname === '/demio') {
            pageTitle = 'Completed webcasts';
            buttons = (
                // @ts-expect-error
                <Link variant='button-secondary' size='big' to='/demio/upcoming' as={RouterLink}>
                    Upcoming webcasts
                </Link>
            );
        }

        return (
            <PageTitleBar
                title={pageTitle}
                subheaderPrimaryText='Internal page only!'
                subheaderSecondaryText='Demio'
                buttons={buttons}
            />
        );
    }
}

const PageTitleBarContainerRouted = withRouter(PageTitleBarContainer);
